import React, { useState } from "react"
import { Link, graphql } from "gatsby"

import Layout from "../components/layout"

import SEO from "../components/seo"
import Episode from "../components/episode"
import GoetheImage from "../components/goethe-image"
import EnterImage from "../components/enter-image"

const IndexPage = ({ data }) => {
  const [currentEpisode, setCurrentEpisode] = useState(0)
  return (
    <Layout>
      <SEO title="Home" />
      <section className="section dark-section">
        <div className="container" style={{marginTop: '-20px'}}>
          <div className="columns">
            <div className="column is-two-thirds">
              <p className="text-color-white is-size-5">
                Walk With Me is a fictionalised audio series of my exploration
                of Johannesburg, through some of her most historical and least
                seen spaces. <br/>Join me, and listen in on intimate conversations
                with locals who share experiences and views that will surprise
                you and what you thought you knew about South Africa.
              </p>
              <br />
              <p className="text-color-white is-size-5">Enjoy,</p>
              <p className="text-color-white is-size-5">Anonymous</p>
            </div>
            <div className="column">
              <div className="columns is-mobile">
                <div className="column">
                  <div className="center-block">
                    <EnterImage />
                  </div>
                </div>
                <div className="column">
                  <div className="center-block">
                    <GoetheImage />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="section" style={{paddingTop: 0, paddingBottom: 0}}>
      {data.allEpisodesJson.edges.map(({ node }, id) => (
        currentEpisode===id && <Episode key={node.id} content={node} next={()=>{
          setCurrentEpisode(currentEpisode+1)}} prev={()=>setCurrentEpisode(currentEpisode-1)} showPrev={id>0} showNext={id<data.allEpisodesJson.edges.length-1} />
      ))}
      </section>
    </Layout>
  )
}

export default IndexPage

export const query = graphql`
  query EpisodesQuery {
    allEpisodesJson {
      edges {
        node {
          description
          id
          name
          no
          track
          start{
            zoom
            lat
            long
            name
            text
            image {
            id
          }
          }
          locations {
            end
            image {
            id
          }
            lat
            long
            name
            start
            zoom
          }
        }
      }
    }
  }
`
